import type { PropsWithChildren } from 'react';
import type React from 'react';
import { styled } from 'styled-components';

import { Media } from '../../theme/Media.tsx';

const Wrapper = styled.div`
  position: relative;
  @media ${Media.smMin} {
    flex: 0 0 220px;
  }
`;

export interface ISelect extends PropsWithChildren {
  dataTestId?: string;
}

const Select: React.FC<ISelect> = ({ children, dataTestId }) => <Wrapper data-testid={dataTestId}>{children}</Wrapper>;

export default Select;
